import { render, staticRenderFns } from "./addLogin.vue?vue&type=template&id=5e0f8053&scoped=true&"
import script from "./addLogin.vue?vue&type=script&lang=js&"
export * from "./addLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f8053",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0f8053')) {
      api.createRecord('5e0f8053', component.options)
    } else {
      api.reload('5e0f8053', component.options)
    }
    module.hot.accept("./addLogin.vue?vue&type=template&id=5e0f8053&scoped=true&", function () {
      api.rerender('5e0f8053', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/addLogin.vue"
export default component.exports